export default {
  setThemes: (state, payload) => {
    state.themes.list = payload.list;
    state.themes.main = payload.main;
    state.themes.selected = payload.selected;
    state.themes.type = payload.type;
    state.themes.loading = payload.loading;
  },
  setThemesLoading: (state, payload) => {
    state.themes.loading = payload;
  },
  changeStep: (state, payload) => {
    state.navbarstep = payload;
  },
};
